<div class="loader-overlay" *ngIf="loader$ | async">
  <div class="loader"></div>
</div>